import { render, staticRenderFns } from "./Kategori.vue?vue&type=template&id=02107cff&scoped=true&"
import script from "./Kategori.vue?vue&type=script&lang=js&"
export * from "./Kategori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02107cff",
  null
  
)

export default component.exports